export default __webpack_public_path__ + "static/media/code.23ef7252.webp";